(function ($) {
    'use strict';

    const LOCKED_CLASS = 'catalyst-locked';
    const LOCK_BUTTON_SELECTOR = '.catalyst-lock-toggle';
    const BULK_SELECTED_CLASS = 'catalyst-bulk-selected';
    const BULK_LIGHTBOX_CLASS = 'catalyst-bulk-reveal';

    function reorderLockedCards($container) {
        if (!$('body').hasClass('template-catalyst')) {
            return;
        }
        if (!$container || !$container.length) {
            $container = $('#collection .collection-cards');
        }
        if (!$container.length) {
            return;
        }
        const $locked = $container.children('.card[data-catalyst-locked="1"]');
        if ($locked.length === 0) {
            return;
        }
        $locked.each(function () {
            const $card = $(this);
            $container.append($card);
        });
    }

    window.catalystAfterSort = function ($container) {
        reorderLockedCards($container);
    };

    function ensureLockButton($card) {
        if (!$card || !$card.length || $card.find(LOCK_BUTTON_SELECTOR).length) {
            return;
        }
        const locked = $card.attr('data-catalyst-locked') === '1';
        const $button = $('<button/>', {
            'type': 'button',
            'class': 'catalyst-lock-toggle',
            'data-locked': locked ? 1 : 0,
            'aria-pressed': locked ? 'true' : 'false',
            'title': locked ? t('js.catalyst.unlock_title') : t('js.catalyst.lock_title'),
            text: locked ? '🔒' : '🔓'
        });

        const $levelBadge = $card.find('.card-level').first();
        if ($levelBadge.length) {
            $button.insertAfter($levelBadge);
        } else {
            $card.prepend($button);
        }
    }

    function refreshLockButtonAvailability($card) {
        const $btn = $card.find(LOCK_BUTTON_SELECTOR);
        if (!$btn.length) {
            return;
        }
        const hide = $card.hasClass('already-in-deck') || $card.hasClass('in-deck');
        $btn.toggleClass('is-hidden', hide);
        $btn.prop('disabled', hide);
    }

    function applyLockState($card, locked) {
        const normalized = locked ? '1' : '0';
        $card.attr('data-catalyst-locked', normalized);
        $card.toggleClass(LOCKED_CLASS, locked);

        const $btn = $card.find(LOCK_BUTTON_SELECTOR);
        if ($btn.length) {
            $btn.attr('data-locked', normalized);
            $btn.attr('aria-pressed', locked ? 'true' : 'false');
            $btn.attr('title', locked ? t('js.catalyst.unlock_title') : t('js.catalyst.lock_title'));
            $btn.text(locked ? '🔒' : '🔓');
        }

        refreshLockButtonAvailability($card);
    }

    function decorateLockableCard($card) {
        ensureLockButton($card);
        const locked = $card.attr('data-catalyst-locked') === '1';
        applyLockState($card, locked);
    }

    function isLocked($card) {
        return $card.attr('data-catalyst-locked') === '1';
    }

    $(document).ready(function () {
        const $catalyst = $('#catalyst');
        const $collection = $('.template-catalyst #collection');
        const $collectionGrid = $collection.find('.collection-cards');

        if (typeof cards_in_deck !== 'undefined') {
            cards_in_deck.forEach(function (cardId) {
                const $card = $collectionGrid.find(`.card[data-id="${cardId}"]`);
                if ($card.length) {
                    $card.addClass('already-in-deck');
                    $card.append(`<span class="emoji-pin" title="${t('js.catalyst.pin_title')}">📌</span>`);
                }
            });
        }

        $collectionGrid.find('.card').each(function () {
            decorateLockableCard($(this));
        });
        reorderLockedCards($collectionGrid);

        const $bulkLevelButtons = $('#catalyst-bulk-levels .catalyst-level-chip');
        const $bulkLevelsBlock = $('.catalyst-bulk-levels-block');
        const $bulkRunBtn = $('#catalyst-bulk-run');
        const $bulkRunLabel = $bulkRunBtn.find('.catalyst-bulk-run-label');
        const $bulkRunCount = $bulkRunBtn.find('.catalyst-bulk-run-count');
        const $bulkRunHint = $bulkRunBtn.find('.catalyst-bulk-run-hint');
        const bulkRunBaseLabel = $bulkRunLabel.length ? ($bulkRunLabel.data('baseLabel') || $bulkRunLabel.text()) : '';
        const $bulkStatus = $('#catalyst-bulk-status');
        const $bulkPanel = $('#catalyst-bulk-panel');
        const levelLabels = (typeof catalystLevels !== 'undefined' && catalystLevels) ? catalystLevels : {};
        const bulkStatusDefault = $bulkStatus.length ? $bulkStatus.text() : '';
        const bulkResultCards = [];
        const bulkState = {
            active: false,
            level: null,
            selectedIds: new Set(),
            processing: false
        };
        const STICKY_TOLERANCE = 2;

        function applyActiveLevelFilter($cards) {
            const $targetCards = $cards && $cards.length ? $cards : $collectionGrid.children('.card');
            const activeLevel = bulkState.active
                && bulkState.level !== null
                && typeof bulkState.level !== 'undefined'
                && bulkState.level !== ''
                ? String(bulkState.level)
                : null;

            $targetCards.each(function () {
                const $card = $(this);
                const level = String($card.attr('data-level') || '');
                const shouldHide = activeLevel !== null && level !== activeLevel;
                $card.toggleClass('is-catalyst-filter-hidden', shouldHide);
            });
        }

        function getBulkStickyTop() {
            if (!$bulkPanel.length) {
                return 0;
            }
            const computedTop = parseFloat(window.getComputedStyle($bulkPanel.get(0)).top);
            return Number.isFinite(computedTop) ? computedTop : 0;
        }

        function setBulkVisibility(hasEligible) {
            if ($bulkPanel.length) {
                $bulkPanel.show();
                $bulkPanel.removeClass('has-no-bulk');
                $bulkPanel.toggleClass('is-bulk-disabled', !hasEligible);
            }
            if ($bulkLevelsBlock.length) {
                $bulkLevelsBlock.toggleClass('is-disabled', !hasEligible);
                $bulkLevelsBlock.toggleClass('is-hidden', !hasEligible);
                $bulkLevelsBlock.attr('aria-disabled', hasEligible ? 'false' : 'true');
                $bulkLevelsBlock.attr('aria-hidden', hasEligible ? 'false' : 'true');
            }
        }

        function sortCollectionByLevel() {
            if (!$collectionGrid.length) {
                return;
            }
            const cards = $collectionGrid.children('.card').get();
            if (!cards.length) {
                return;
            }
            cards.sort(function (a, b) {
                const $a = $(a);
                const $b = $(b);
                const levelA = parseInt($a.attr('data-level'), 10) || 0;
                const levelB = parseInt($b.attr('data-level'), 10) || 0;
                if (levelA !== levelB) {
                    return levelA - levelB;
                }
                const discA = $a.data('discovery') || '';
                const discB = $b.data('discovery') || '';
                if (discA === discB) {
                    return 0;
                }
                return discA < discB ? 1 : -1;
            });
            $collectionGrid.append(cards);
        }

        function computeEligibleCounts() {
            const counts = {};
            $collectionGrid.find('.card').each(function () {
                const $card = $(this);
                const level = $card.attr('data-level');
                if (typeof level === 'undefined' || level === null) {
                    return;
                }
                if (isEligibleForBulk($card, level)) {
                    counts[level] = (counts[level] || 0) + 1;
                }
            });
            return counts;
        }

        function refreshStickyHeader() {
            if (!$bulkPanel.length) {
                return;
            }
            if (!$bulkPanel.is(':visible')) {
                $bulkPanel.removeClass('is-sticky');
                return;
            }
            const rect = $bulkPanel.get(0).getBoundingClientRect();
            const stickyTop = getBulkStickyTop();
            const shouldStick = rect.top <= (stickyTop + STICKY_TOLERANCE);
            $bulkPanel.toggleClass('is-sticky', shouldStick);
        }

        function rebuildLevelOptions() {
            if (!$bulkLevelButtons.length) {
                updateBulkStatus();
                refreshStickyHeader();
                return;
            }
            const eligibleCounts = computeEligibleCounts();
            const currentVal = bulkState.level;

            $bulkLevelButtons.each(function () {
                const $btn = $(this);
                const level = $btn.data('level');
                const count = eligibleCounts[level] || 0;
                const eligible = count >= 5;
                $btn
                    .toggleClass('is-unavailable', !eligible)
                    .prop('disabled', bulkState.processing || !eligible)
                    .attr('aria-hidden', eligible ? 'false' : 'true');
            });

            const hasEligible = Object.keys(eligibleCounts).some(function (level) {
                return (eligibleCounts[level] || 0) >= 5;
            });
            if (!hasEligible) {
                clearBulkSelection(true);
            }

            const hasCurrentLevel = currentVal !== null
                && typeof currentVal !== 'undefined'
                && currentVal !== '';
            const $currentButton = hasCurrentLevel
                ? $bulkLevelButtons.filter(`[data-level="${currentVal}"]`)
                : $();
            const keepCurrent = hasCurrentLevel
                && $currentButton.length > 0
                && !$currentButton.hasClass('is-unavailable');
            if (!keepCurrent) {
                bulkState.level = null;
                bulkState.active = false;
                bulkState.selectedIds.clear();
                $collectionGrid.find('.' + BULK_SELECTED_CLASS).removeClass(BULK_SELECTED_CLASS).removeAttr('data-bulk-selected');
            }

            $bulkLevelButtons.removeClass('is-active').attr('aria-pressed', 'false');
            if (keepCurrent && bulkState.level) {
                $bulkLevelButtons.filter(`[data-level="${bulkState.level}"]`).addClass('is-active').attr('aria-pressed', 'true');
            }

            applyActiveLevelFilter();
            updateBulkStatus();

            setBulkVisibility(hasEligible);
            refreshStickyHeader();
        }

        function getLevelLabel(level) {
            if (levelLabels && Object.prototype.hasOwnProperty.call(levelLabels, level)) {
                return levelLabels[level];
            }
            return level;
        }

        function isEligibleForBulk($card, level) {
            if (!$card || !$card.length) {
                return false;
            }
            if (String($card.attr('data-level')) !== String(level)) {
                return false;
            }
            if ($card.hasClass('already-in-deck') || $card.hasClass('in-deck')) {
                return false;
            }
            return !isLocked($card);
        }

        function toggleBulkSelectionForCard($card, shouldSelect) {
            const cardId = $card.attr('data-id');
            if (!cardId) {
                return;
            }
            if (shouldSelect) {
                bulkState.selectedIds.add(cardId.toString());
                $card.attr('data-bulk-selected', '1').addClass(BULK_SELECTED_CLASS);
            } else {
                bulkState.selectedIds.delete(cardId.toString());
                $card.removeAttr('data-bulk-selected').removeClass(BULK_SELECTED_CLASS);
            }
        }

        function setBulkProcessing(isProcessing) {
            bulkState.processing = isProcessing;
            if ($bulkLevelButtons.length) {
                $bulkLevelButtons.each(function () {
                    const $button = $(this);
                    $button.prop('disabled', isProcessing || $button.hasClass('is-unavailable'));
                });
            }
            updateBulkStatus();
        }

        function updateBulkRunLabel(count) {
            if (!$bulkRunBtn.length) {
                return;
            }
            const safeCount = Math.max(0, count || 0);
            if ($bulkRunLabel.length) {
                $bulkRunLabel.text(bulkRunBaseLabel || $bulkRunLabel.text());
            }
            if ($bulkRunCount.length) {
                $bulkRunCount.text(`(${safeCount})`);
            }
        }

        function updateBulkRunHint(batches) {
            if (!$bulkRunHint.length) {
                return;
            }
            if (batches < 1) {
                $bulkRunHint.text($bulkRunHint.data('emptyLabel') || '');
                return;
            }

            const sourceLevel = parseInt(bulkState.level, 10);
            const resultLevel = Number.isFinite(sourceLevel) ? Math.min(sourceLevel + 1, 7) : null;
            const resultLevelLabel = resultLevel === null ? '' : getLevelLabel(String(resultLevel));

            if (batches === 1) {
                const template = $bulkRunHint.data('oneLabel') || '';
                $bulkRunHint.text(String(template).replace('{level}', resultLevelLabel));
                return;
            }
            const template = $bulkRunHint.data('manyLabel') || '';
            $bulkRunHint.text(
                String(template)
                    .replace('{count}', batches)
                    .replace('{level}', resultLevelLabel)
            );
        }

        function updateBulkStatus(customText) {
            const counts = computeEligibleCounts();
            const count = bulkState.selectedIds.size;
            const batches = Math.floor(count / 5);
            const leftover = count % 5;
            const hasSelection = count > 0;
            const levelSelected = bulkState.level !== null && bulkState.level !== '';
            const availableAtLevel = levelSelected ? (counts[bulkState.level] || 0) : 0;
            const hasEnoughAtLevel = availableAtLevel >= 5;
            const hasLevelOptions = $bulkLevelButtons.length ? $bulkLevelButtons.filter(function () { return !$(this).prop('disabled'); }).length > 0 : false;
            const hasEligible = Object.keys(counts).some(function (level) {
                return (counts[level] || 0) >= 5;
            });

            let text = customText || '';
            if (!text) {
                if (!bulkState.active) {
                    text = bulkStatusDefault || t('js.catalyst.bulk_empty_hint');
                } else {
                    text = t('js.catalyst.bulk_selected', {
                        count,
                        batches,
                        leftover,
                        level: getLevelLabel(bulkState.level)
                    });
                }
            }

            if ($bulkStatus.length) {
                $bulkStatus.text(text);
            }

            updateBulkRunLabel(count);
            updateBulkRunHint(batches);
            setBulkVisibility(hasEligible);

            if ($bulkRunBtn.length) {
                const disableRun = bulkState.processing || batches === 0 || !hasEligible;
                $bulkRunBtn.prop('disabled', disableRun);
                $bulkRunBtn.toggleClass('is-disabled', disableRun);
                $bulkRunBtn.toggleClass('is-active', !disableRun);
                $bulkRunBtn.attr('aria-disabled', disableRun ? 'true' : 'false');
            }
        }

        function clearBulkSelection(resetLevel = true) {
            bulkState.active = false;
            if (resetLevel) {
                bulkState.level = null;
                if ($bulkLevelButtons.length) {
                    $bulkLevelButtons.removeClass('is-active').attr('aria-pressed', 'false');
                }
            }
            bulkState.selectedIds.clear();
            $collectionGrid.find('.' + BULK_SELECTED_CLASS).removeClass(BULK_SELECTED_CLASS).removeAttr('data-bulk-selected');
            applyActiveLevelFilter();
            updateBulkStatus();
        }

        function selectAllForLevel(level) {
            const eligibleCounts = computeEligibleCounts();
            if ((eligibleCounts[level] || 0) < 5) {
                alert(t('js.catalyst.bulk_not_enough'));
                clearBulkSelection();
                rebuildLevelOptions();
                return;
            }
            bulkState.active = true;
            bulkState.level = level;
            bulkState.selectedIds.clear();
            $collectionGrid.find('.' + BULK_SELECTED_CLASS).removeClass(BULK_SELECTED_CLASS).removeAttr('data-bulk-selected');

            if ($bulkLevelButtons.length) {
                $bulkLevelButtons.removeClass('is-active').attr('aria-pressed', 'false');
                $bulkLevelButtons.filter(`[data-level="${level}"]`).addClass('is-active').attr('aria-pressed', 'true');
            }

            $collectionGrid.find('.card').each(function () {
                const $card = $(this);
                if (isEligibleForBulk($card, level)) {
                    toggleBulkSelectionForCard($card, true);
                } else if (String($card.attr('data-level')) === String(level)) {
                    toggleBulkSelectionForCard($card, false);
                }
            });

            applyActiveLevelFilter();
            updateBulkStatus();
        }

        function handleBulkCardClick($card) {
            if (!bulkState.active || bulkState.processing) {
                return false;
            }
            if (String($card.attr('data-level')) !== String(bulkState.level)) {
                return false;
            }
            if (!isEligibleForBulk($card, bulkState.level)) {
                return false;
            }

            const isSelected = $card.hasClass(BULK_SELECTED_CLASS);
            toggleBulkSelectionForCard($card, !isSelected);
            updateBulkStatus();
            return true;
        }

        function prepareNewCard(cardHtml) {
            const $newCardHtml = $(cardHtml);
            $newCardHtml.removeClass('unrevealed zoomed');
            $newCardHtml.find('.card-back').remove();
            if (!$newCardHtml.attr('data-catalyst-locked')) {
                $newCardHtml.attr('data-catalyst-locked', '0');
            }
            ensureLockButton($newCardHtml);
            applyLockState($newCardHtml, false);
            $newCardHtml.removeAttr('data-bulk-selected').removeClass(BULK_SELECTED_CLASS);
            $newCardHtml.hide();
            return $newCardHtml;
        }

        function buildBulkSlide(cardHtml) {
            const $card = $(cardHtml);
            $card.addClass('booster-large');
            const currentStyle = $card.attr('style') || '';
            const cleanedStyle = currentStyle.replace(/display\s*:\s*none;?/i, '');
            if (cleanedStyle !== currentStyle) {
                $card.attr('style', cleanedStyle);
            }
            return $('<div class="booster-slide"></div>').append($card);
        }

        function normalizeCardPreviewHtml(cardHtml) {
            if (!cardHtml) {
                return '';
            }
            const $card = $(cardHtml);
            $card.addClass('unrevealed-ready').removeClass('zoomed');
            $card.find('.card-back').remove();
            const currentStyle = $card.attr('style') || '';
            const cleanedStyle = currentStyle.replace(/display\s*:\s*none;?/i, '').trim();
            if (cleanedStyle) {
                $card.attr('style', cleanedStyle);
            } else {
                $card.removeAttr('style');
            }
            $card.css({ display: '', visibility: '', opacity: '' });
            return $card.prop('outerHTML');
        }

        function updateBulkPeekState($context) {
            const $slides = $context.find('.booster-slide');
            const $active = $context.find('.booster-slide.is-active');
            const activeIndex = $slides.index($active);
            const hasPrev = activeIndex > 0;
            const hasNext = activeIndex !== -1 && activeIndex < $slides.length - 1;
            $context.find('.booster-prev-peek').toggleClass('visible', hasPrev);
            $context.find('.booster-next-peek').toggleClass('visible', hasNext);
        }

        function setBulkActiveCard($context, $card, behavior = 'smooth') {
            if (!$card || !$card.length) {
                return;
            }
            const $slide = $card.closest('.booster-slide');
            if (!$slide.length) {
                return;
            }
            $context.find('.booster-slide.is-active').removeClass('is-active');
            $slide.addClass('is-active');
            const slideNode = $slide.get(0);
            if (slideNode && typeof slideNode.scrollIntoView === 'function') {
                slideNode.scrollIntoView({ behavior, inline: 'center', block: 'nearest' });
            }
            updateBulkPeekState($context);
        }

        function renderBulkBoosterPreview(cardsHtml) {
            if (!cardsHtml || !cardsHtml.length) {
                return;
            }

            const slidesMarkup = cardsHtml.map(function (html) {
                const $slide = buildBulkSlide(html);
                return $slide.prop('outerHTML');
            }).join('');

            const lightboxContent = `
                <div class="${BULK_LIGHTBOX_CLASS} template-open-booster" style="--open-booster-action-height:0px;--header-height:0px;--footer-height:0px;">
                    <div class="booster-slider-outer">
                        <button type="button" class="booster-prev-peek" aria-label="Previous">
                            <span class="peek-arrow">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                                    <path d="M15 6L9 12L15 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </span>
                        </button>
                        <div class="booster-slider">
                            <div class="booster-cards booster-track">
                                ${slidesMarkup}
                            </div>
                        </div>
                        <button type="button" class="booster-next-peek" aria-label="Next">
                            <span class="peek-arrow">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                                    <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </span>
                        </button>
                    </div>
                </div>`;

            handleLightbox(lightboxContent);
            const $lightbox = $('.lightbox');
            const $lightboxContent = $lightbox.find('.' + BULK_LIGHTBOX_CLASS);
            const $cards = $lightboxContent.find('.card');
            $cards.each(function () {
                $(this).css({ display: 'block', visibility: 'visible', opacity: 1 }).addClass('unrevealed-ready');
            });
            applyCircleType($lightboxContent);
            setBulkActiveCard($lightboxContent, $cards.first(), 'auto');

            function closeBulkLightbox() {
                $lightbox.fadeOut(300, function () {
                    $lightbox.removeClass('active');
                    $(document).trigger('lightboxClosed');
                });
            }

            $lightboxContent.on('click', '.card', function () {
                setBulkActiveCard($lightboxContent, $(this));
            });
            $lightboxContent.on('click', '.booster-next-peek', function (e) {
                e.preventDefault();
                e.stopPropagation();
                const $slides = $lightboxContent.find('.booster-slide');
                const $active = $lightboxContent.find('.booster-slide.is-active');
                const activeIndex = $slides.index($active);
                if (activeIndex !== -1 && activeIndex < $slides.length - 1) {
                    setBulkActiveCard($lightboxContent, $slides.eq(activeIndex + 1).find('.card'));
                }
            });
            $lightboxContent.on('click', '.booster-prev-peek', function (e) {
                e.preventDefault();
                e.stopPropagation();
                const $slides = $lightboxContent.find('.booster-slide');
                const $active = $lightboxContent.find('.booster-slide.is-active');
                const activeIndex = $slides.index($active);
                if (activeIndex > 0) {
                    setBulkActiveCard($lightboxContent, $slides.eq(activeIndex - 1).find('.card'));
                }
            });

            $lightboxContent.on('click', function (e) {
                const isInsideSlider = $(e.target).closest('.booster-slider-outer').length > 0;
                if (!isInsideSlider) {
                    closeBulkLightbox();
                }
            });

            $lightbox.on('click.bulkClose', function (e) {
                const clickedCard = $(e.target).closest('.card');
                const clickedControl = $(e.target).closest('.booster-prev-peek, .booster-next-peek');
                if (!clickedCard.length && !clickedControl.length) {
                    closeBulkLightbox();
                }
            });
        }

        function processBulkBatch(cardIds) {
            return new Promise(function (resolve, reject) {
                $.ajax({
                    url: '/ajax/catalyst-plunge',
                    method: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify({ card_ids: cardIds }),
                    success: function (response) {
                        if (response && response.error) {
                            reject(response.error);
                            return;
                        }

                        cardIds.forEach(function (cardId) {
                            bulkState.selectedIds.delete(cardId.toString());
                            const $card = $collectionGrid.find(`.card[data-id="${cardId}"]`);
                            if ($card.length) {
                                $card.fadeOut(200, function () {
                                    $(this).remove();
                                });
                            }
                        });

                        if (response && response.cardHtml) {
                            const $preparedCard = prepareNewCard(response.cardHtml);
                            $collectionGrid.append($preparedCard);
                            applyActiveLevelFilter($preparedCard);
                            $preparedCard.fadeIn(200);
                            rebindTooltips($preparedCard);
                            applyCircleType($preparedCard);
                            sortCollectionByLevel();
                            const previewHtml = normalizeCardPreviewHtml(response.cardHtml);
                            if (previewHtml) {
                                bulkResultCards.push(previewHtml);
                            }
                        }

                        const $sortSelect = $('#search-form select[name="sort-by"]');
                        if ($sortSelect.length) {
                            $sortSelect.trigger('change');
                        } else {
                            $('#search-form input[name="sort-by"]:checked').trigger('change');
                        }
                        sortCollectionByLevel();
                        reorderLockedCards($collectionGrid);
                        rebuildLevelOptions();
                        updateBulkStatus();
                        resolve(response);
                    },
                    error: function (jqXHR) {
                        let message = t('js.common.error_generic');
                        if (jqXHR.responseJSON && jqXHR.responseJSON.error) {
                            message = jqXHR.responseJSON.error;
                        }
                        reject(message);
                    }
                });
            });
        }

        function runBulkQueue(queue, totalBatches, doneBatches) {
            if (!queue.length) {
                clearBulkSelection(true);
                setBulkProcessing(false);
                updateBulkStatus(t('js.catalyst.bulk_done', { gained: doneBatches }));
                if (bulkResultCards.length > 1) {
                    renderBulkBoosterPreview(bulkResultCards);
                } else if (bulkResultCards.length === 1) {
                    try {
                        const $card = $(bulkResultCards[0]);
                        const $zoom = typeof zoomCard === 'function' ? zoomCard($card) : $card;
                        handleLightbox($zoom);
                    } catch (e) {
                        // ignore preview failure
                    }
                }
                bulkResultCards.length = 0;
                return;
            }

            updateBulkStatus(t('js.catalyst.bulk_processing', { done: doneBatches, total: totalBatches }));

            const nextBatch = queue.shift();
            processBulkBatch(nextBatch)
                .then(function () {
                    runBulkQueue(queue, totalBatches, doneBatches + 1);
                })
                .catch(function (message) {
                    setBulkProcessing(false);
                    bulkResultCards.length = 0;
                    updateBulkStatus(message || t('js.common.error_generic'));
                    alert(message || t('js.common.error_generic'));
                });
        }

        function getCardPriorityMetrics(cardId) {
            const $card = $collectionGrid.find(`.card[data-id="${cardId}"]`);
            if (!$card.length) {
                return { bonusCount: Infinity, statSum: Infinity };
            }
            const bonusCount = $card.find('.card-bonuses li').length || 0;
            const attack = parseInt($.trim($card.find('.card-attack').text()), 10) || 0;
            const defense = parseInt($.trim($card.find('.card-defense').text()), 10) || 0;
            return {
                bonusCount,
                statSum: attack + defense
            };
        }

        function startBulkProcessing() {
            if (bulkState.processing) {
                return;
            }
            const level = bulkState.level;
            if (level === null || level === '') {
                alert(t('js.catalyst.bulk_select_level'));
                return;
            }

            const availableCounts = computeEligibleCounts();
            const availableAtLevel = availableCounts[level] || 0;
            if (availableAtLevel < 5) {
                console.log('Bulk catalyst requires at least 5 eligible cards at the selected level.');
                alert(t('js.catalyst.bulk_not_enough'));
                rebuildLevelOptions();
                return;
            }

            const ids = Array.from(bulkState.selectedIds).map(function (id) { return parseInt(id, 10); }).filter(function (id) { return id > 0; });
            const batchesReady = Math.floor(ids.length / 5);
            if (!batchesReady) {
                console.log('Bulk catalyst requires at least 5 selected cards to start.');
                alert(t('js.catalyst.bulk_not_enough'));
                return;
            }

            const prioritizedIds = ids.map(function (id, index) {
                const metrics = getCardPriorityMetrics(id);
                return {
                    id,
                    bonusCount: metrics.bonusCount,
                    statSum: metrics.statSum,
                    index
                };
            }).sort(function (a, b) {
                if (a.bonusCount !== b.bonusCount) {
                    return a.bonusCount - b.bonusCount;
                }
                if (a.statSum !== b.statSum) {
                    return a.statSum - b.statSum;
                }
                return a.index - b.index;
            }).map(function (entry) {
                return entry.id;
            });

            const usableIds = prioritizedIds.slice(0, batchesReady * 5);
            console.log(`Bulk catalyst ready: ${usableIds.length} cards selected (${batchesReady} batch${batchesReady > 1 ? 'es' : ''}).`);
            const confirmMsg = t('js.catalyst.bulk_confirm', { count: usableIds.length, level: getLevelLabel(level) });
            const confirmation = confirm(confirmMsg);
            if (!confirmation) {
                return;
            }

            setBulkProcessing(true);
            bulkResultCards.length = 0;
            updateBulkStatus(t('js.catalyst.bulk_processing', { done: 0, total: batchesReady }));
            const queue = [];
            for (let i = 0; i < usableIds.length; i += 5) {
                queue.push(usableIds.slice(i, i + 5));
            }
            runBulkQueue(queue, batchesReady, 0);
        }

        if ($bulkRunBtn.length) {
            $bulkRunBtn.on('click', function () {
                startBulkProcessing();
            });
        }

        if ($bulkLevelButtons.length) {
            $bulkLevelButtons.on('click', function () {
                if (bulkState.processing) {
                    return;
                }
                const $btn = $(this);
                if ($btn.prop('disabled')) {
                    return;
                }
                const isAlreadyActive = $btn.hasClass('is-active');
                if (isAlreadyActive) {
                    clearBulkSelection(true);
                    if ($bulkLevelButtons.length) {
                        $bulkLevelButtons.removeClass('is-active').attr('aria-pressed', 'false');
                    }
                    return;
                }
                const newLevel = $btn.data('level');
                bulkState.level = String(newLevel);
                selectAllForLevel(bulkState.level);
            });
        }

        rebuildLevelOptions();

        updateBulkStatus();
        refreshStickyHeader();
        sortCollectionByLevel();
        reorderLockedCards($collectionGrid);
        applyActiveLevelFilter();

        $(window).on('scroll resize', refreshStickyHeader);

        if ($catalyst.length) {
            const $sortSelect = $('#search-form select[name="sort-by"]');
            if ($sortSelect.length) {
                $sortSelect.val('level-asc').trigger('change');
            } else {
                $('#search-form input[name="sort-by"][value="level-asc"]').prop('checked', true).trigger('change');
            }
        }

        $(document).on('lightboxClosed.catalyst', function () {
            rebuildLevelOptions();
            updateBulkStatus();
            refreshStickyHeader();
            sortCollectionByLevel();
            reorderLockedCards($collectionGrid);
        });

        $collection.on('click', '.card', function () {
            const $card = $(this);

            if (bulkState.processing || $card.hasClass('in-deck') || isLocked($card)) {
                return;
            }

            const cardLevel = $card.attr('data-level');
            if (bulkState.level === null || typeof bulkState.level === 'undefined' || bulkState.level === '') {
                bulkState.level = cardLevel;
                bulkState.active = true;
                if ($bulkLevelButtons.length) {
                    $bulkLevelButtons.removeClass('is-active').attr('aria-pressed', 'false');
                    $bulkLevelButtons.filter(`[data-level="${cardLevel}"]`).addClass('is-active').attr('aria-pressed', 'true');
                }
                applyActiveLevelFilter();
            } else if (String(bulkState.level) !== String(cardLevel)) {
                alert(t('js.catalyst.same_level_required'));
                return;
            }

            const isSelected = $card.hasClass(BULK_SELECTED_CLASS);
            toggleBulkSelectionForCard($card, !isSelected);
            if (bulkState.selectedIds.size > 0) {
                bulkState.active = true;
            } else {
                clearBulkSelection(true);
                return;
            }
            updateBulkStatus();
        });

        $collection.on('click', LOCK_BUTTON_SELECTOR, function (event) {
            event.preventDefault();
            event.stopPropagation();

            const $button = $(this);
            if (bulkState.processing || $button.prop('disabled')) {
                return;
            }

            const $card = $button.closest('.card');
            if ($card.hasClass('in-deck') || $card.hasClass('already-in-deck')) {
                return;
            }

            const currentLocked = isLocked($card);
            const nextState = !currentLocked;
            const cardId = parseInt($card.attr('data-id'), 10);

            if (!cardId) {
                return;
            }

            if ($button.data('loading')) {
                return;
            }

            $button.data('loading', true).addClass('is-loading');

            $.ajax({
                url: '/ajax/catalyst-lock',
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({ card_id: cardId, locked: nextState }),
                success: function (response) {
                    if (response && response.error) {
                        alert(response.error);
                        return;
                    }

                    const locked = response && typeof response.locked !== 'undefined' ? !!response.locked : nextState;
                    applyLockState($card, locked);
                    if (locked && bulkState.active) {
                        toggleBulkSelectionForCard($card, false);
                        if (bulkState.selectedIds.size === 0) {
                            clearBulkSelection(true);
                        } else {
                            updateBulkStatus();
                        }
                    }
                    rebuildLevelOptions();
                    const $sortSelect = $('#search-form select[name="sort-by"]');
                    if ($sortSelect.length) {
                        $sortSelect.trigger('change');
                    } else {
                        $('#search-form input[name="sort-by"]:checked').trigger('change');
                    }
                },
                error: function (jqXHR) {
                    let message = t('js.catalyst.lock_failed');
                    if (jqXHR.responseJSON && jqXHR.responseJSON.error) {
                        message = jqXHR.responseJSON.error;
                    }
                    alert(message);
                },
                complete: function () {
                    $button.data('loading', false).removeClass('is-loading');
                }
            });
        });

    });
})(jQuery);
